import React, { useState } from "react";
import { toast } from "sonner";
import { X } from "lucide-react";
import { api } from "../api";

export const PasswordModal = ({ open, onClose }) => {
  const [busy, setBusy] = useState(false);
  if (!open) return null;

  const submit = async (e) => {
    e.preventDefault();
    const f = new FormData(e.target);
    if (f.get("new_password") !== f.get("confirm")) return toast.error("كلمتا السر غير متطابقتين");
    setBusy(true);
    try {
      const { data } = await api.post("/auth/change-password", {
        current_password: f.get("current_password"), new_password: f.get("new_password"),
      });
      if (data.token) localStorage.setItem("el_token", data.token);
      toast.success("تم تغيير كلمة السر بنجاح");
      onClose();
    } catch (err) {
      toast.error(err?.response?.data?.detail || "تعذّر تغيير كلمة السر");
    } finally { setBusy(false); }
  };

  return (
    <div className="fixed inset-0 z-[80] bg-[#04102a]/75 backdrop-blur-md grid place-items-center p-4"
      onClick={onClose}>
      <div className="glass w-full max-w-md p-6" data-testid="password-modal"
        onClick={(e) => e.stopPropagation()}>
        <div className="flex items-center justify-between mb-5">
          <h3 className="text-xl font-black text-white">تغيير كلمة السر</h3>
          <button onClick={onClose} data-testid="password-modal-close"
            className="p-2 rounded-xl bg-white/10 text-white/80 hover:bg-white/20"><X size={16} /></button>
        </div>
        <form onSubmit={submit} className="space-y-3">
          <input name="current_password" type="password" className="input" required dir="ltr"
            placeholder="كلمة السر الحالية" data-testid="current-password" />
          <input name="new_password" type="password" className="input" required dir="ltr"
            placeholder="كلمة السر الجديدة (8 أحرف وأرقام على الأقل)" data-testid="new-password" />
          <input name="confirm" type="password" className="input" required dir="ltr"
            placeholder="تأكيد كلمة السر الجديدة" data-testid="confirm-password" />
          <button disabled={busy} data-testid="save-password-btn"
            className="pro-btn text-white w-full disabled:opacity-60"
            style={{ background: "linear-gradient(180deg,#3fa9ff,#1e63c8)" }}>
            {busy ? "جارٍ الحفظ..." : "حفظ كلمة السر"}</button>
        </form>
      </div>
    </div>
  );
};
